<template>
  <div>
    <b-card class="page-card">
      <div class="page-header d-flex justify-content-between">
        <h2>Parts Order {{ partsOrderId }}</h2>
      </div>
      <div v-if="loading" class="text-center py-4">
        <b-spinner></b-spinner>
      </div>
      <div v-else>
        <parts-order-summary />

        <b-row class="mt-2">
          <h5>Parts</h5>
        </b-row>
        <b-table
          class="border"
          no-border-collapse
          striped
          sticky-header="63vh"
          :items="filteredPartsOrderItems(partsOrder.partsOrderItems)"
          :fields="fields"
        >
          <template #cell(amtPrice)="{ item }">
            <div>{{ item.amtPrice | currency }}</div>
          </template>
          <template #cell(extendedPrice)="{ item }">
            <div>{{ extendedPrice(item) | currency }}</div>
          </template>
        </b-table>
        <div>
          <b-col sm="5" lg="3" xl="2">
            <b-form-group
              label-cols="6"
              label="Subtotal:"
              label-for="subTotal"
              class="m-0"
              label-class="font-weight-bold"
            >
              <div id="subTotal" class="col-form-label text-right">
                <b>{{ partsOrder.subTotal | currency }}</b>
              </div>
            </b-form-group>
            <b-form-group label-cols="6" label="Sales Tax:" label-for="salesTax" class="m-0">
              <div id="salesTax" class="col-form-label text-right">
                {{ partsOrder.amtTax | currency }}
              </div>
            </b-form-group>
            <b-form-group label-cols="6" label="Total:" label-for="total" class="m-0" label-class="font-weight-bold">
              <div id="total" class="col-form-label text-right">
                <b>{{ (partsOrder.subTotal + partsOrder.amtTax) | currency }}</b>
              </div>
            </b-form-group>
          </b-col>
        </div>
        <div v-if="comment" class="mt-4 mb-4">
          <h5>Comment</h5>
          <b-row>
            <b-col md="12">
              <span>{{ comment }}</span>
            </b-col>
          </b-row>
        </div>
        <div v-show="partsOrder.shipId.toLowerCase() !== 'pickup'" class="mt-4 mb-4">
          <h5>Shipping Info</h5>
          <b-row>
            <b-col>
              {{ partsOrder.shipAddr1 }}
              <br />
              <template v-if="partsOrder.shipAddr2">
                {{ partsOrder.shipAddr2 }}
                <br />
              </template>
              {{ partsOrder.shipCity }}, {{ partsOrder.shipState }} {{ partsOrder.shipPost }}
            </b-col>
          </b-row>
        </div>
        <div>
          <billing-and-payment
            :allow-e-pay-in-person="allowEPayInPerson"
            :allow-e-pay="allowEPay"
            :po-number="poNumber"
            :order-id="partsOrderId"
            :invoice-order-id="invoiceSlsId"
            :order="partsOrder"
            :customer-id="customerId"
            :is-authorized="true"
            :visible="true"
          />
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import PartsOrderSummaryComponent from './PartsOrderSummaryComponent.vue';
import BillingAndPaymentComponent from '@/shared/components/ui/BillingAndPaymentComponent';

import { mapActions, mapGetters } from 'vuex';
import { PartsOrderActions, PartsOrderGetters } from '@/shared/store/parts-order/types';
import { CustomerActions } from '@/shared/store/customer/types';

export default {
  name: 'PartsOrderPage',
  components: {
    'parts-order-summary': PartsOrderSummaryComponent,
    'billing-and-payment': BillingAndPaymentComponent
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      partsOrder: PartsOrderGetters.GET_PARTS_ORDER
    }),
    fields() {
      let fields = [];
      fields.push({ key: 'partNumber', label: 'Part No', sortable: false });
      fields.push({ key: 'partDescription', label: 'Part Description', sortable: false });
      fields.push({ key: 'qtyShip', label: 'Qty Shipped', sortable: false, thStyle: 'width: 45px' });
      fields.push({ key: 'qtyBackorder', label: 'Qty Backorder', sortable: false, thStyle: 'width: 45px' });
      fields.push({ key: 'amtPrice', label: 'Amt Price', sortable: false, thStyle: 'width: 45px' });
      fields.push({ key: 'extendedPrice', label: 'Extended Price', sortable: false, thStyle: 'width: 45px' });

      return fields;
    },
    partsOrderId() {
      return this.$route.params.partsOrderId;
    },
    invoiceSlsId() {
      return this.partsOrder.invoiceSlsId;
    },
    allowEPayInPerson() {
      return this.partsOrder.allowEPayInPerson;
    },
    allowEPay() {
      return this.partsOrder.allowEPay;
    },
    poNumber() {
      return this.partsOrder.poNumber;
    },
    customerId() {
      return this.partsOrder.customerId;
    }
  },
  watch: {
    '$route.path': {
      async handler() {
        this.fetchPartsOrder();
      }
    }
  },
  async created() {
    this.fetchPartsOrder();
  },
  methods: {
    ...mapActions([PartsOrderActions.FETCH_PARTS_ORDER, CustomerActions.FETCH_CUSTOMER]),
    async fetchPartsOrder() {
      this.loading = true;
      let order = await this[PartsOrderActions.FETCH_PARTS_ORDER](this.partsOrderId);
      await this[CustomerActions.FETCH_CUSTOMER](order.customerId);
      this.loading = false;
    },
    extendedPrice(item) {
      return item.qtyShip * item.amtPrice;
    },
    filteredPartsOrderItems(items) {
      if (!items) {
        return [];
      }
      return items.filter(item => !(item.qtyBackorder === 0 && item.qtyShip === 0 && item.itmType !== 532));
    }
  }
};
</script>
